import { useCallback, useEffect, useRef, useState } from 'react';

export const useScrollToTop = (threshold: number = 90) => {
    const [showScrollToTop, setShowScrollToTop] = useState(false);
    const scrollRef = useRef<HTMLDivElement>(null);

    const handleScroll = useCallback(() => {
        if (scrollRef.current) {
            const { scrollTop } = scrollRef.current;
            setShowScrollToTop(scrollTop > threshold);
        }
    }, [threshold]);

    useEffect(() => {
        const scrollElement = scrollRef.current;
        if (scrollElement) {
            scrollElement.addEventListener('scroll', handleScroll);
            return () => scrollElement.removeEventListener('scroll', handleScroll);
        }
    }, [handleScroll]);

    const scrollToTop = () => {
        if (scrollRef.current) {
            scrollRef.current.scrollTo({
                top: 0,
                behavior: 'smooth'
            });
        }
    };

    return { scrollRef, showScrollToTop, scrollToTop };
};
